import ReportType from './reportType.js';
export default ReportType;
